export const setPatients = (patients) => {
  return {
    type: 'setPatients',
    patients: patients
  }
}
